import React from "react";

// Função para calcular a diferença em dias entre a data de validade e a data atual
const calculateDaysLeft = (validade) => {
  const today = new Date();
  const expDate = new Date(validade);
  const diffTime = expDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};
const getUrgencyBadgeClass = (daysLeft) => {
  if (daysLeft < 15) return "bg-danger";
  if (daysLeft < 30) return "bg-warning";
  if (daysLeft < 45) return "bg-info";
  if (daysLeft < 60) return "bg-success";
  return "bg-secondary";
};

// Função para definir a categoria com base nos dias restantes
const getValidityCategory = (daysLeft) => {
  if (daysLeft <= 0) return "Vencido";
  if (daysLeft < 15) return "< 15 dias";
  if (daysLeft < 30) return "< 30 dias";
  if (daysLeft < 45) return "< 45 dias";
  if (daysLeft < 60) return "< 60 dias";
  return "OK";
};

function ExpiringItemsTable({ expiringItems }) {
  const sortedExpiringItems = expiringItems.slice().sort((a, b) => calculateDaysLeft(a.data_validade) - calculateDaysLeft(b.data_validade));

  return (
    <div className="col-md-12 col-lg-12 mb-2">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Itens com Validade Próxima</h3>
        </div>
        <div className="card-table table-responsive">
          <table className="table table-vcenter">
            <thead>
              <tr>
                <th>Item</th>
                <th>Data de Validade</th>
                <th>Dias Restantes</th>
                <th>Categoria</th>
              </tr>
            </thead>
            <tbody>
              {sortedExpiringItems && sortedExpiringItems.length > 0 ? (
                sortedExpiringItems.map((item) => {
                  const daysLeft = calculateDaysLeft(item.data_validade);
                  if (daysLeft < 60) {
                    return (
                      <tr key={item.id}>
                        <td>{item.descricao}</td>
                        <td>{new Date(item.data_validade).toLocaleDateString()}</td>
                        <td>{daysLeft}</td>
                        <td>
                          <span className={`badge ${getUrgencyBadgeClass(daysLeft)} me-1 text-white`}>
                            {getValidityCategory(daysLeft)}
                          </span>
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    Nenhum item encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ExpiringItemsTable;